import { GET } from './api';

const table = 'distributors';

export const ReadBankingRules = async (id) => {
  return await GET(`/${table}/rules/${id}`, true);
};
